// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"023b4cbb","72":"023b4cbb","139":"023b4cbb","235":"023b4cbb","256":"023b4cbb","296":"023b4cbb","437":"023b4cbb","447":"023b4cbb","614":"023b4cbb","630":"023b4cbb","635":"023b4cbb","883":"023b4cbb","897":"023b4cbb","920":"023b4cbb"}[chunkId] + ".chunk.css";
};